// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mes-documents {
  padding: 2rem;
  max-width: 120rem;
  margin: 0 auto;
}

.mes-documents h1 {
  margin-bottom: 3rem;
}

.loading-text,
.error-text {
  text-align: center;
  padding: 2rem;
  font-size: 1.6rem;
}

.error-text {
  color: #D32F2F;
}

.loading-text {
  color: #666;
}

/* .document-section {
  background-color: #FFFDFC;
  padding: 2rem;
  border-radius: 0.8rem;
  margin-bottom: 2rem;
  position: relative;
} */

/* .document-section h2 {
  color: #2C3948;
  margin-bottom: 1rem;
} */

.document-section .documents-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

.document-card {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  background-color: rgba(215, 217, 217, 0.20);
  border-radius: 10px;
  transition: transform 0.2s, box-shadow 0.2s, background-color 0.2s;
  min-height: 8rem;
  text-align: center;
}

.document-card.clickable {
  cursor: pointer;
}

.document-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: rgba(215, 217, 217, 0.30);
}

.document-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 0.8rem;
  text-align: center;
}

.document-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 0.8rem;
  width: 100%;
}

.document-name {
  font-size: 1.5rem;
  color: #2C3948;
  text-align: center !important;
  font-weight: 600;
  width: 100%;
  line-height: 1.3;
  word-break: break-word;
  display: block;
  margin: 0 auto;
}

.document-date {
  font-size: 1.2rem;
  color: #666;
  text-align: center;
  font-style: italic;
  line-height: 1.3;
}

.document-comment {
  font-size: 1.2rem;
  color: #666;
  margin: 0;
}

.document-actions {
  display: flex;
  gap: 1rem;
}

.document-actions button {
  white-space: nowrap;
}

/* .section-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
} */

.section-header h2 {
  font-size: 1.8rem;
  font-weight: 600;
  color: #2C3948;
}

.view-more-icon {
  width: 2rem;
  height: 2rem;
  color: #2C3948;
  cursor: pointer;
  transition: color 0.2s, transform 0.2s;
  margin-top: 0.5rem;
}

.view-more-icon:hover {
  color: #1A2634;
  transform: scale(1.1);
}

.add-document-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
}

.info-text {
  text-align: center;
  color: #666;
  font-size: 1.4rem;
  padding: 2rem;
}

/* Nouveaux styles pour les types de documents */
.new-document-types {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 2rem;
}

.new-document-type-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  background-color: rgba(215, 217, 217, 0.10);
  border-radius: 0.8rem;
  transition: background-color 0.2s;
}

.new-document-type-item:hover {
  background-color: rgba(215, 217, 217, 0.20);
}

.new-document-type-item span {
  font-size: 1.4rem;
  color: #2C3948;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 768px) {
  .mes-documents {
    padding: 1rem;
  }

  .document-section .documents-grid {
    grid-template-columns: repeat(auto-fill, minmax(10rem, 1fr));
    gap: 1rem;
  }

  .new-document-type-item {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }

  .new-document-type-item button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/composants/MesDocuments/MesDocuments.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;GAMG;;AAEH;;;GAGG;;AAEH;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,2CAA2C;EAC3C,mBAAmB;EACnB,kEAAkE;EAClE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;GAKG;;AAEH;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,2CAA2C;EAC3C,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".mes-documents {\r\n  padding: 2rem;\r\n  max-width: 120rem;\r\n  margin: 0 auto;\r\n}\r\n\r\n.mes-documents h1 {\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.loading-text,\r\n.error-text {\r\n  text-align: center;\r\n  padding: 2rem;\r\n  font-size: 1.6rem;\r\n}\r\n\r\n.error-text {\r\n  color: #D32F2F;\r\n}\r\n\r\n.loading-text {\r\n  color: #666;\r\n}\r\n\r\n/* .document-section {\r\n  background-color: #FFFDFC;\r\n  padding: 2rem;\r\n  border-radius: 0.8rem;\r\n  margin-bottom: 2rem;\r\n  position: relative;\r\n} */\r\n\r\n/* .document-section h2 {\r\n  color: #2C3948;\r\n  margin-bottom: 1rem;\r\n} */\r\n\r\n.document-section .documents-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));\r\n  gap: 2rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.document-card {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 2rem 1.5rem;\r\n  background-color: rgba(215, 217, 217, 0.20);\r\n  border-radius: 10px;\r\n  transition: transform 0.2s, box-shadow 0.2s, background-color 0.2s;\r\n  min-height: 8rem;\r\n  text-align: center;\r\n}\r\n\r\n.document-card.clickable {\r\n  cursor: pointer;\r\n}\r\n\r\n.document-card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  background-color: rgba(215, 217, 217, 0.30);\r\n}\r\n\r\n.document-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  gap: 0.8rem;\r\n  text-align: center;\r\n}\r\n\r\n.document-details {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  gap: 0.8rem;\r\n  width: 100%;\r\n}\r\n\r\n.document-name {\r\n  font-size: 1.5rem;\r\n  color: #2C3948;\r\n  text-align: center !important;\r\n  font-weight: 600;\r\n  width: 100%;\r\n  line-height: 1.3;\r\n  word-break: break-word;\r\n  display: block;\r\n  margin: 0 auto;\r\n}\r\n\r\n.document-date {\r\n  font-size: 1.2rem;\r\n  color: #666;\r\n  text-align: center;\r\n  font-style: italic;\r\n  line-height: 1.3;\r\n}\r\n\r\n.document-comment {\r\n  font-size: 1.2rem;\r\n  color: #666;\r\n  margin: 0;\r\n}\r\n\r\n.document-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n}\r\n\r\n.document-actions button {\r\n  white-space: nowrap;\r\n}\r\n\r\n/* .section-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  margin-bottom: 1rem;\r\n} */\r\n\r\n.section-header h2 {\r\n  font-size: 1.8rem;\r\n  font-weight: 600;\r\n  color: #2C3948;\r\n}\r\n\r\n.view-more-icon {\r\n  width: 2rem;\r\n  height: 2rem;\r\n  color: #2C3948;\r\n  cursor: pointer;\r\n  transition: color 0.2s, transform 0.2s;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.view-more-icon:hover {\r\n  color: #1A2634;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.add-document-container {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.info-text {\r\n  text-align: center;\r\n  color: #666;\r\n  font-size: 1.4rem;\r\n  padding: 2rem;\r\n}\r\n\r\n/* Nouveaux styles pour les types de documents */\r\n.new-document-types {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.new-document-type-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 1.5rem;\r\n  background-color: rgba(215, 217, 217, 0.10);\r\n  border-radius: 0.8rem;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.new-document-type-item:hover {\r\n  background-color: rgba(215, 217, 217, 0.20);\r\n}\r\n\r\n.new-document-type-item span {\r\n  font-size: 1.4rem;\r\n  color: #2C3948;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .mes-documents {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .document-section .documents-grid {\r\n    grid-template-columns: repeat(auto-fill, minmax(10rem, 1fr));\r\n    gap: 1rem;\r\n  }\r\n\r\n  .new-document-type-item {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .new-document-type-item button {\r\n    width: 100%;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
